import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=4d95faf2&scoped=true&"
import script from "./RichTextEditor.vue?vue&type=script&lang=ts&"
export * from "./RichTextEditor.vue?vue&type=script&lang=ts&"
import style1 from "./RichTextEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d95faf2",
  null
  
)

export default component.exports